import { Component, OnInit } from '@angular/core';
import { URLS } from '../../constants/URLS';
import { MycontentserviceService } from '../../_service/mycontentservice.service';
import { MycontentComponent } from '../mycontent/mycontent.component';
import { DeleteService } from 'src/app/_service/delete.service';
import { Router } from '@angular/router';
import { WalletinfoService } from 'src/app/_service/walletinfo.service';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';

@Component({
  selector: 'app-watchlist',
  templateUrl: './watchlist.component.html',
  styleUrls: ['./watchlist.component.css']
})
export class WatchlistComponent implements OnInit {

  mediaUrl: String = URLS.BASE_URL + '/static/post_videos/';
  ccPrimeWatchlist:any[] = [];
  activeTab: string = 'ccPrime';
  firstVideo:any;
  watchList: any[] = [];
  userName:string;
  mycontentcompo: MycontentComponent;
  isLoading:boolean=false;
  userId:string;
  
  constructor(
    private mycontentservice: MycontentserviceService, 
    private watchlistService: DeleteService,
    private router: Router,
    private walletService: WalletinfoService,
    private toastrService: CustomControlsService
    ) { }

  ngOnInit(): void {
    this.isLoading=true;
    console.log("WatchlistComponent called..");
    this.userId = localStorage.getItem('userId');
    if(this.userId){
      this.getWatchListContents();
    }
    this.ccPrimeWatchlist = this.watchlistService.getWatchlist();
    this.userName = localStorage.getItem('screenName')
  }

  getWatchListContents(){
    this.mycontentservice.getWatchListOfUser(this.userId).subscribe(result2 => {  
      result2.forEach(movie => {
        this.mycontentservice.transformData(movie);
        if (movie.content_sub_type === '1') {
          this.ccPrimeWatchlist.push(movie);
        } else if (movie.content_sub_type === '2') {
          this.watchList.push(movie);
        } else{
          this.watchList.push(movie);
        }
      });
      this.firstVideo = this.ccPrimeWatchlist[0];
      console.log(this.ccPrimeWatchlist);
      this.mapwatchContent();
      this.mapChannelSubscription();

      this.isLoading;
      console.log(this.watchList)
    },(error)=>{
      this.isLoading = false;
    });
  }

  mapwatchContent() {
    var usrId = localStorage.getItem("userId");
    this.mycontentservice.getWatchListOfUser(usrId).subscribe(watchresult => { 
      this.watchList.forEach(section => {
        section.isInWatchList = false;
          watchresult.forEach(wlitem => {
            if (section.vidLibId == wlitem.vidLibId) {
              section.isInWatchList = true;
            }
          })
        
      })
    });
    this.isLoading=false
  }

  mapChannelSubscription() {
    this.walletService.getUserSubscriptions().subscribe(result =>{
      this.watchList.forEach(section => {
          result?.forEach(sitem => {
            if(section.channelId == sitem.channelId && sitem.isActive){
              section.isChannelSubscribed = true;
              section.expiringDate = sitem.dateOfExpiry;
            }
            if((section.vidLibId == sitem.contentId || section.vidLibId == sitem.vidLibId) && sitem.isActive){
              section.isPPVSubscribed = true;
              section.expiringDate = sitem.dateOfExpiry;
            }else if(section.channelId == sitem.channelId && sitem.isActive && section.sub_value === '0'){
              section.isPPVSubscribed = true;
              section.expiringDate = sitem.dateOfExpiry;
            }
          })
      })
    })
  }

  stopPropagation(event: MouseEvent) {
    event.stopPropagation();
  }

  removeFromWatchList(event: Event,vidLibId) {
    event.preventDefault();
    var userId = localStorage.getItem("userId");
    this.mycontentservice.removeFromWatchList(userId, vidLibId).subscribe(result => { //126
      console.log("after remove watch list", result);
      if (result == 0) {
        this.isLoading = true;
        this.getWatchListContents();
        this.showSuccess("successfully removed to the watchlist..");
      } else if (result == 1) {
        this.showWarning("unable to remove please try again..");
      }
    })
  }

  showWarning(message:any) {
    this.toastrService.showNotification(
      'warning',
      '',
      message,
      3000
    );
  }

  showSuccess(message:any) {
    this.toastrService.showNotification(
      'success',
      '',
      message,
      3000
    );
  }

  openVideoPlayer(video: any) {
    const videoIndex = this.ccPrimeWatchlist.findIndex(item => item.vidLibId === video.vidLibId);
    this.router.navigate(['/video'], {
      queryParams: {
        vidLibId: video.vidLibId,
        list: 'wl',
        index: videoIndex
      }
    });
  }
  
}